<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :content="page.content" />

		<route-descriptions
			:header="defaults[locale].contact.routeHeader"
			:items="defaults[locale].contact.routeDescription"
		/>

		<section class="main-content background-light">
			<div class="row contact-form-row">
				<div class="columns column12 maps">
					<iframe
						id="maps"
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2436.289345896992!2d4.870793676984755!3d52.365173247680545!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c609e12d399a87%3A0xd1481925c1299b29!2sHotel%20Mosaic!5e0!3m2!1snl!2snl!4v1685526855860!5m2!1snl!2snl"
						width="100%"
						height="450"
						style="border: 0"
						allowfullscreen=""
						loading="lazy"
					/>
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();

if (!defaults.value) {
	await fetchDefaults();
}
</script>

<style lang="scss" scoped>
#maps {
	min-height: 600px;
	height: 100%;
	width: 100%;
}

.contact-form-row {
	display: flex;
	align-items: center;
	flex-flow: row wrap;
	justify-content: flex-end;
	padding: 0;
	margin: 40px auto;

	.columns:first-child {
		padding: 0;
	}

	.contact-form-col {
		padding: 50px 0;
		position: relative;
		z-index: 2;
	}

	.contentblock-content {
		padding: 75px;
		background: #fff;
	}
}

@media (max-width: 1080px) {
	#maps {
		min-height: 400px;
	}

	.contact-form-row {
		.maps {
			width: 100%;
			position: relative;
		}

		.contact-form-col {
			padding: 0;
			width: 92%;
			margin: -25px auto 0;
		}

		.contentblock-content {
			padding: 50px;
		}
	}
}

@media (max-width: 580px) {
	.contact-form-row {
		margin-bottom: 25px;

		.contentblock-content {
			padding: 35px;
		}
	}
}
</style>
